import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { getAuthenticationConfig } from '../../guard/authentication.config';
import { APP_CONFIG } from '../../../tokens/app-config.token';
import { Environment } from '../../../../environments/environment.interface';
import { AuthRouteName } from './auth.config';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly authConfig: ReturnType<typeof getAuthenticationConfig>;

  constructor(
    private readonly cookieService: CookieService,
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
  ) {
    this.authConfig = getAuthenticationConfig(this.appConfig);
  }

  navigateToLoginPage() {
    this.clearTokenFromCookie();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = `${this.appConfig.WEBSITE}/${AuthRouteName.Login}`;
    }
  }

  clearTokenFromCookie() {
    this.cookieService.delete(this.authConfig.authTokenKeyName, '/', this.authConfig.cookieAuthTokenDomain);
    this.cookieService.delete(this.authConfig.notificationCookie, '/', this.authConfig.cookieAuthTokenDomain);
  }
}
